module.exports = __webpack_public_path__ + "static/media/Roboto-Italic.fd597012.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Italic.woff
// module id = 547
// module chunks = 0